import Overlay from 'src/js/components/overlay';

export default class Dropdown {
  constructor() {
    if ($('.dropdown').length) {
      this.overlay = new Overlay
      this.addListeners();
    }
  }

  addListeners() {
    $('.dropdown-label').on('click touchstart', function(e){
      e.stopPropagation();
    });

    $('.dropdown-label').on('click', this.handleLabelClick.bind(this));
    $(document).on('click touchstart', this.handleClick.bind(this));
  }

  closeDropdowns() {
    if ($(".dropdown").hasClass("active")) {
      $(".dropdown").removeClass('active');
      $(".dropdown").find('.dropdown-content').attr("tabindex", '-1');
      this.overlay.close();
    }
  }


  handleLabelClick(event) {
    event.stopPropagation();
    var $parent = $(event.target).parent('.dropdown');
    var active = !$parent.hasClass('active')
    this.closeDropdowns();

    if (active) {
      $parent.addClass('active');
      $parent.find('.dropdown-content').attr('tabindex', '0');
      if ($parent.hasClass('with-overlay')) {
        this.overlay.open();
      }
    }
  }

  handleClick(event) {
    if (!$(event.target).parents('.dropdown').length) {
      this.closeDropdowns();
    }
  }
}
